import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const DetailRightContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: ${1100 * Screen.widthRatio}px;
  top: ${655 * Screen.widthRatio}px;
`;

export default DetailRightContainer;
